import React from 'react';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

const getCategoryIcon = (category) => {
  const icons = {
    venue: '🏰',
    catering: '🍽️',
    photographer: '📸',
    dj: '🎵',
    flowers: '💐',
    transport: '🚗',
    planner: '📋'
  };
  return icons[category.toLowerCase()] || '💰';
};

export default function BudgetResults({ results, onReset }) {
  if (!results || results.error) return null;

  const { usTotal, mexicoTotal, savings, breakdown } = results;
  const savingsPercentage = usTotal > 0 ? Math.round((savings / usTotal) * 100) : 0;

  return (
    <div className="space-y-8">
      <div className="text-center mb-6">
        <h2 className="text-3xl font-bold text-[#181c24] mb-2 tracking-tight">Your Wedding Budget Comparison</h2>
        <p className="text-[#666] text-lg">See how much you could save by having your wedding in Mexico</p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-2xl shadow border border-[#ececec]">
          <thead>
            <tr className="bg-[#fafbfc] text-[#181c24] text-lg">
              <th className="py-4 px-4 text-left font-semibold rounded-tl-2xl">Category</th>
              <th className="py-4 px-4 text-right font-semibold">U.S.</th>
              <th className="py-4 px-4 text-right font-semibold">Mexico</th>
              <th className="py-4 px-4 text-right font-semibold rounded-tr-2xl">Savings</th>
            </tr>
          </thead>
          <tbody>
            {breakdown.map(({ category, us, mexico }) => {
              const catKey = category.toLowerCase();
              const catSavings = us - mexico;
              return (
                <tr key={category} className="hover:bg-[#f7f7f7] transition-colors group">
                  <td className="py-3 px-4 flex items-center gap-3 text-[#181c24] font-medium">
                    <span className="text-2xl">{getCategoryIcon(catKey)}</span>
                    <span>
                      {category}
                      {catKey === 'catering' && <span className="ml-1 text-xs text-[#7ec4b8]">(per guest)</span>}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right text-[#181c24]">{formatCurrency(us)}</td>
                  <td className="py-3 px-4 text-right text-[#181c24]">{formatCurrency(mexico)}</td>
                  <td className={`py-3 px-4 text-right font-semibold ${catSavings > 0 ? 'text-[#5ec2b7]' : catSavings < 0 ? 'text-[#bf6a6a]' : 'text-[#888]'}`}>{catSavings > 0 ? `+${formatCurrency(catSavings)}` : catSavings < 0 ? `-${formatCurrency(Math.abs(catSavings))}` : '-'}</td>
              </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="bg-[#fafbfc] text-lg font-bold">
              <td className="py-4 px-4 text-[#181c24] rounded-bl-2xl">Total</td>
              <td className="py-4 px-4 text-right text-[#181c24]">{formatCurrency(usTotal)}</td>
              <td className="py-4 px-4 text-right text-[#181c24]">{formatCurrency(mexicoTotal)}</td>
              <td className="py-4 px-4 text-right text-[#5ec2b7] rounded-br-2xl">
                {savings > 0 ? `+${formatCurrency(savings)}` : savings < 0 ? `-${formatCurrency(Math.abs(savings))}` : '-'}
                <span className="ml-2 text-base font-normal text-[#888]">({savingsPercentage}% savings)</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="flex flex-wrap gap-4 justify-center mt-6">
      <button
        onClick={onReset}
          className="px-6 py-3 bg-[#bfa76a] text-white rounded-xl font-semibold shadow hover:bg-[#a8905d] active:bg-[#907c4f] transition-colors"
      >
        Start Over
      </button>
        <button
          className="px-6 py-3 bg-[#5ec2b7] text-white rounded-xl font-semibold shadow hover:bg-[#4bb0a6] active:bg-[#3a8c85] transition-colors"
          onClick={() => window.print()}
        >
          Download PDF
        </button>
        <button
          className="px-6 py-3 bg-[#ececec] text-[#181c24] rounded-xl font-semibold shadow hover:bg-[#e0e0e0] active:bg-[#d4d4d4] transition-colors"
          onClick={() => {navigator.clipboard.writeText(window.location.href)}}
        >
          Copy Link
        </button>
      </div>
    </div>
  );
} 